/*
 *   This will build into .js and .css files that can be rendered:
 *
 *   include:    {% load render_bundle from webpack_loader %}
 *   head:       {% render_bundle 'client_bundle' 'css' %}
 *   footer:     {% render_bundle 'client_bundle' 'js' %}
 */
import 'core-js/stable';
import './common/js/polyfills';
import { configure } from 'mobx';

import * as Sentry from '@sentry/react';
import blacklistedUrls from './exception-handling/blacklisted-urls';
import blacklistedErrors from './exception-handling/blacklisted-errors';

import './common/css/styles.scss';
import './common/css/auth.scss';

/* react app */
import '../react/auth_index';

configure({
  enforceActions: 'never',
});

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://b66899ef04f24590954284699e871c64@sentry.io/1223003',
    environment: process.env.NODE_ENV,
    release: process.env.sentryConfig.release,
    denyUrls: blacklistedUrls,
    ignoreErrors: blacklistedErrors,
  });

  const scope = Sentry.getCurrentScope();
  scope.setTag('bundle', 'Auth');
  scope.setExtra('appState', window.appState);

  window.Sentry = Sentry;
} else {
  window.Sentry = { captureException: console.error };
}

moment.locale(window.appState.lang);
